module.exports = __webpack_public_path__ + "img/minus.d6cfe62b.svg";